import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useClickAway } from 'ahooks'
import classNames from 'classnames'
import request from '../../../utils/request'
import globalData from '../../../common/globalData'
import { renderCompat } from '../../../utils/renderCompat'
import './index.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    renderCompat(<CollectBehaviorTip {...props} visible container={div} />, div)
  })
}

let timer = null

const CollectBehaviorTip = ({ onClose, scrollRoot = window, className, style, contentStyle, unmount }) => {
  const [count, setCount] = useState(5)
  const timeFlag = useRef(false)
  useEffect(() => {
    return () => {
      destroy()
    }
  }, [])

  useEffect(() => {
    if (count <= 0) {
      destroy()
    }
  }, [count])

  const destroy = () => {
    setCount(5)
    clearInterval(timer)
    close?.()
  }

  const close = () => {
    unmount && unmount()
    onClose && onClose()
  }

  const onCount = () => {
    timer = setInterval(() => {
      setCount(pre => pre - 1)
    }, 1000)
  }

  useEffect(() => {
    const onScroll = () => {
      if (!timeFlag.current) {
        timeFlag.current = true
        onCount()
      }
    }
    scrollRoot.addEventListener('scroll', onScroll)
    return () => {
      scrollRoot.removeEventListener('scroll', onScroll)
    }
  }, [])
  const domRef = useRef()

  useClickAway(() => {
    if (!timeFlag.current) {
      timeFlag.current = true
      onCount()
    }
  }, domRef)

  return ReactDOM.createPortal(<div className={classNames('mnCollectBehaviorTip', className)} style={style} ref={domRef}>
    <div className="mnCollectBehaviorTip-content" style={contentStyle}>
      <div className="mnCollectBehaviorTip-content-close">
        {
          timeFlag.current && `${count}秒后自动收起`
        }
        <img onClick={() => destroy()} src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/collect-notification/%E5%90%91%E4%B8%8B.png" /></div>
      <div className="mnCollectBehaviorTip-content-info">
        <img className="mnCollectBehaviorTip-content-info-image" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/collect-notification/%E9%87%87%E9%9B%86%E6%8F%92%E4%BB%B6.png" />
        <div>采集到美念，批量管理/智能分类图片</div>
      </div>
    </div>
  </div>, document.body)
}

let time2 = null
export const useCollectBehaviorTip = (duration = 5) => {
  const [collectTipFlag, setCollectTipFlag] = useState(false)

  useEffect(() => {
    fetchData()
    return () => {
      setCollectTipFlag(false)
    }
  }, [])

  const fetchData = async () => {
    let flag = false
    const result = await request.get('/zhikuan/mn/propagate/last-month-user-collected')
    const _temp = await globalData.toGet('last-month-user-collected')
    const lastFlag = _temp === null ? true : JSON.parse(_temp)

    if (lastFlag && result) { // 代表一个月未采集并且没有展示过
      globalData.set('last-month-user-collected', true)
      flag = true
    }
    if (!result) { // 一个月内采集过 则充值 展示过得值
      globalData.set('last-month-user-collected', true)
      flag = false
    }
    if (flag) {
      setCollectTipFlag(true)
      time2 = setTimeout(() => {
        setCollectTipFlag(false)
        globalData.set('last-month-user-collected', false)
      }, duration * 1000)
    }
  }

  useEffect(() => {
    return () => {
      clearInterval(time2)
    }
  }, [])

  return {
    collectTipFlag,
  }
}
